// front_erion/src/utils/imageUtils.js

export function handleZoom(currentZoom, change) {
  // 줌 레벨 변경 (최소 10%, 최대 300%)
  // 10% 단위로 변경되도록 수정
  const step = 10; // 10% 단위로 변경
  const newZoom = Math.max(10, Math.min(300, currentZoom + change));
  // 10의 배수로 반올림
  return Math.round(newZoom / step) * step;
}

// 이미지 파일을 Base64 문자열로 변환
export async function fileToBase64(file) {
  console.groupCollapsed('%c[fileToBase64] 실행 시작', 'color:#9b59b6; font-weight:bold;');
  console.time('[fileToBase64] 전체 소요');

  console.log('%c[fileToBase64] 호출 스택:', 'color:#9b59b6; font-weight:bold;');
  console.trace(); // 호출 위치 추적

  console.log('%c[fileToBase64] 파일 유효성 검증 시작', 'color:#f39c12;');
  if (!file || !(file instanceof File)) {
    console.error('%c[fileToBase64] 파일 비정상:', 'color:#e74c3c;', file);
    console.groupEnd();
    return '';
  }
  console.log('%c[fileToBase64] [검증 통과] 파일 정보', 'color:#2ecc71;', {
    name: file.name,
    type: file.type,
    size: `${file.size} bytes`
  });

  // 1차 시도: File.arrayBuffer()
  console.group('%c[fileToBase64] 1차 시도: arrayBuffer()', 'color:#3498db;');
  console.time('[fileToBase64] 1차 소요');
  try {
    console.log('%c[fileToBase64] arrayBuffer 변환 시도', 'color:#3498db;');
    const buffer = await file.arrayBuffer();
    console.log('%c[fileToBase64] arrayBuffer 변환 성공', 'color:#2ecc71;', buffer.byteLength);
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i += 8192) {
      binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
    }
    const base64String = btoa(binary);
    console.timeEnd('[fileToBase64] 1차 소요');
    console.groupEnd();
    console.timeEnd('[fileToBase64] 전체 소요');
    console.groupEnd();
    return `data:${file.type};base64,${base64String}`;
  } catch (err) {
    console.warn('%c[fileToBase64] [실패] arrayBuffer 변환 실패', 'color:#e67e22;', err);
    console.timeEnd('[fileToBase64] 1차 소요');
    console.groupEnd();
  }

  // 2차 시도: fetch(objectURL) → arrayBuffer
  console.group('%c[fileToBase64] 2차 시도: fetch(objectURL)', 'color:#3498db;');
  console.time('[fileToBase64] 2차 소요');
  try {
    const tmpUrl = URL.createObjectURL(file);
    console.log('%c[fileToBase64] 임시 URL 생성', 'color:#f39c12;', tmpUrl);
    
    const response = await fetch(tmpUrl);
    console.log('%c[fileToBase64] fetch 응답 수신 완료', 'color:#2ecc71;');

    const blob = await response.blob();
    console.log('%c[fileToBase64] blob 변환 완료', 'color:#2ecc71;');

    URL.revokeObjectURL(tmpUrl);
    console.log('%c[fileToBase64] 임시 URL 해제 완료', 'color:#f39c12;');

    const buf = await blob.arrayBuffer();
    console.log('%c[fileToBase64] arrayBuffer 변환 성공', 'color:#2ecc71;', `길이: ${buf.byteLength}`);
    
    const bytes2 = new Uint8Array(buf);
    let binary2 = '';
    for (let i = 0; i < bytes2.byteLength; i += 8192) {
      binary2 += String.fromCharCode(...bytes2.subarray(i, i + 8192));
    }
    const base64String = btoa(binary2);
    console.timeEnd('[fileToBase64] 2차 소요');
    console.groupEnd();
    console.timeEnd('[fileToBase64] 전체 소요');
    console.groupEnd();
    return `data:${file.type};base64,${base64String}`;
  } catch (err2) {
    console.warn('%c[fileToBase64] [실패] fetch 변환 실패', 'color:#e67e22;', err2);
    console.timeEnd('[fileToBase64] 2차 소요');
    console.groupEnd();
  }

  // 3차 시도: FileReader
  console.group('%c[fileToBase64] 3차 시도: FileReader', 'color:#3498db;');
  console.time('[fileToBase64] 3차 소요');
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    console.log('%c[fileToBase64] FileReader 인스턴스 생성', 'color:#3498db;');
    console.log('파일 이름:', file.name);
    console.log('파일 타입:', file.type);
    console.log('파일 크기:', file.size, 'bytes');

    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        console.log('%c[fileToBase64] [성공] FileReader 변환 완료', 'color:#2ecc71;');
        console.timeEnd('[fileToBase64] 3차 소요');
        console.groupEnd();
        console.timeEnd('[fileToBase64] 전체 소요');
        console.groupEnd();
        resolve(result);
      } else {
        console.error('%c[fileToBase64] [실패] 예상치 못한 결과 타입', 'color:#e74c3c;', typeof result);
        reject(new Error('Unexpected reader result type'));
      }
    };
    reader.onerror = e => {
      console.error('%c[fileToBase64] [실패] FileReader 에러', 'color:#e74c3c;', reader.error || e);
      console.timeEnd('[fileToBase64] 3차 소요');
      console.groupEnd();
      reject(reader.error || e);
    };

    try {
      console.log('%c[fileToBase64] FileReader.readAsDataURL 호출', 'color:#f39c12;');
      reader.readAsDataURL(file); // 기본 라이브러리 함수라서 추가 로그는 넣을 수 없음
      console.log('%c[fileToBase64] readAsDataURL 호출 완료', 'color:#3498db;');
    } catch (syncErr) {
      console.error('%c[fileToBase64] [실패] FileReader 동기 에러', 'color:#e74c3c;', syncErr);
      console.timeEnd('[fileToBase64] 3차 소요');
      console.groupEnd();
      reject(syncErr);
    }
  });
}

// 이미지 크기 가져오기
export function getImageDimensions(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height
      });
    };
    img.onerror = reject;
    img.src = src;
  });
}

// 캔버스에 이미지 그리기
export function drawImageOnCanvas(canvas, imageSrc) {
  return new Promise((resolve, reject) => {
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      resolve(ctx.getImageData(0, 0, canvas.width, canvas.height));
    };
    
    img.onerror = reject;
    img.src = imageSrc;
  });
}

// 캔버스 데이터를 Base64로 변환
export function canvasToBase64(canvas, format = 'image/png') {
  return canvas.toDataURL(format);
}

// 마스크 이미지 생성 (투명 배경에 마스킹 영역만 표시)
export function createMaskImage(canvas) {
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d');

  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;

  // 전체 배경을 검은색으로 채움
  tempCtx.fillStyle = 'black';
  tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

  // 마스킹 영역(흰색)을 그대로 복사
  tempCtx.drawImage(canvas, 0, 0);

  // Base64 이미지로 변환하여 반환
  return tempCanvas.toDataURL('image/png');
}

// 이미지 파일을 최대 폭 기준으로 압축
export async function compressImage(file, maxWidth = 1024, mimeType = 'image/jpeg', quality = 0.8) {
  if (!(file instanceof File)) {
    return file;
  }
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > maxWidth) {
        height = Math.round(height * (maxWidth / width));
        width = maxWidth;
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(blob => {
        if (blob) {
          resolve(new File([blob], file.name, { type: mimeType }));
        } else {
          resolve(file);
        }
      }, mimeType, quality);
    };
    img.onerror = async () => {
      try {
        const buf  = await file.arrayBuffer();
        const blob = new Blob([buf], { type: mimeType });
        resolve(new File([blob], file.name, { type: mimeType }));
      } catch (_) {
        resolve(file); // 마지막까지 실패하면 원본 반환
      }
    };
    img.src = URL.createObjectURL(file);
  });
}

/**
 * 전역 파일 다운로드 함수
 * URL로부터 이미지를 가져와 Blob으로 변환 후 강제 다운로드 실행
 * 브라우저의 동일 출처 정책(CORS) 문제를 해결하기 위해 fetch 사용
 * @param {string} url 다운로드할 이미지 URL
 * @param {string} fileName 저장될 파일 이름
 */
export async function downloadFile(url, fileName = `erion_${Date.now()}.png`) {
  if (!url) return;
  
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // 사용 후 URL 메모리 해제
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('이미지 다운로드 중 오류 발생:', error);
    // 실패 시 일반적인 새 탭 열기로 폴백
    window.open(url, '_blank');
  }
}
